import { Scholarship } from '@backrs_ui/common-ui/src/models/scholarship';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';
import { selectIsSharedSessionActive } from '../sharedSession/sharedSession';
import type { RootState } from '../store';

export const scholarshipApi = createApi({
  reducerPath: 'scholarshipApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getScholarshipById: build.query<Scholarship, string>({
      queryFn: async (id, queryApi, _extraOptions, baseQuery): Promise<{ data: Scholarship }> => {
        const state = queryApi.getState() as RootState;
        const isSharedSession: boolean = selectIsSharedSessionActive(state);

        const url: string = isSharedSession
          ? `shared/solution-session/scholarship/${id}`
          : `content-search/scholarship/${id}`;

        return baseQuery({ url }) as Promise<{ data: Scholarship }>;
      },
      keepUnusedDataFor: 60 * 60 * 24,
    }),
  }),
});

export const {
  useGetScholarshipByIdQuery,
  usePrefetch: usePrefetchScholarship,
  util: { resetApiState },
} = scholarshipApi;
